import { useEffect, useState } from 'react';
import { Layouts } from '@/data/libraries/Layouts';
import { useScreenSize, ScreenSize } from '@/ui/hooks/useScreenSize';
import { getUrlFromCssVariable } from '@/domain/utils/CssToImage';
import { Container, Row, Col } from 'react-bootstrap';

import { useAppSelector } from '@/ui/store/helperRedux';
import { RootState } from '@/ui/store/store';

import { IStore } from '@/domain/interfaces/IStore';

import { translate } from '@/domain/utils/translate';
import { getCSSVariableValue } from '@/domain/utils/CssExtractVariable';

import './style.css';

import ColumnCategories from '@/ui/containers/Footer/Columns/ColumnCategories';
import ColumnUsers from '@/ui/containers/Footer/Columns/ColumnUsers';
import ColumnUsersV2 from '@/ui/containers/Footer/Columns/ColumnUsersV2';
import ColumnLogo from '@/ui/containers/Footer/Columns/ColumnLogo';
import ColumnSections from './Columns/ColumnSections';


/** Componente contenedor del footer
 * @component
 */
const Footer = (): JSX.Element => {

  /** URL de la imagen de derechos de autor */
  const imgRightsUrl = getUrlFromCssVariable('--img-rights');
  /** Logo de Webpay en blanco */
  const imgWebPayBlack = getUrlFromCssVariable('--img-webpay-black');

  /** Estado Redux Tienda */
  const storeData = useAppSelector((state: RootState) => state.storeData) as IStore | null;

  /** Hook que contiene las dimensiones de la pantalla y maneja los componentes de acuerdo al resultado obtenido  */
  const { width, maxLargeWidth }: ScreenSize = useScreenSize();

  /** Variable que define si es entorno mobile o desktop */
  const isMobile: boolean = width < maxLargeWidth;

  const showVariantBackground = getCSSVariableValue('--footer-line-background');
  const textVariant = getCSSVariableValue('--show-text-footer-color-variant-light');

  /**Estado que maneja el componente en su modo loading */
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    setIsLoading(true);
    // Simula el tiempo de carga del footer (por ejemplo 3 segundos)
    const loadingTimer = setTimeout(() => {
      setIsLoading(false);
    }, 300);

    return () => clearTimeout(loadingTimer);
  }, []);

  /** Renderizado del componente principal */
  return (
    <Container fluid className='bg-primary-3 py-3'>
      <Container>
        <Row id='footer' className='g-0 '>
          <Col lg={12} className='pt-3'>
            {isLoading ?
              <Container fluid className='p-0'>
                <Row className='gradient-loading mh-2-px py-1 mb-3 '>
                </Row>
              </Container>
              :
              !isMobile && <div className={`${showVariantBackground} mb-4 h-2-px`}></div>
            }
            {isLoading ?
              <Container fluid className='p-0'>
                <Row className='gradient-loading mh-265-px  mb-3 '>
                </Row>
              </Container>
              :
              <Row>
                <Col xs={12}>
                  <Container fluid className='p-0'>
                    <Row className='g-0 d-flex justify-content-between'>
                      {!storeData || storeData?.layoutCode === Layouts.DEFAULT && (
                        <>
                          <ColumnCategories />
                          <ColumnSections />
                          <ColumnUsers />
                        </>
                      )}
                      {storeData?.layoutCode === Layouts.EXCLUSIVE && (
                        <>

                          <ColumnLogo />
                          <ColumnSections />
                          <ColumnUsersV2 />
                        </>
                      )}
                    </Row>
                  </Container>
                </Col>
              </Row>
            }

            {isLoading ?
              <Container fluid className='p-0'>
                <Row className='gradient-loading mh-2-px py-1 '>
                </Row>
              </Container> :
              !isMobile && <div className={`${showVariantBackground} mt-2 h-2-px`}></div>}


            {isLoading ?
              <Container fluid className='p-0'>
                <Row className='gradient-loading mh-50-px rounded mt-4'>
                  <Col lg={5} className='gradient-loading mh-50-px mx-auto my-4'>
                  </Col>
                </Row>
              </Container>
              :
              <Row className=' my-4 g-0 text-center'>
                <Col lg={12}
                  className={`${textVariant} d-flex justify-content-between align-items-center  d-md-block  px-md-3`}
                >
                  <span className='h5'>{translate("footer.payment_methods_text")}</span>
                  <img src={imgWebPayBlack} alt='logo webpay' className='ps-4' />
                </Col>
                <Col lg={12} className='d-flex justify-content-center mt-4 '>
                  <img src={imgRightsUrl} alt='rights'></img>
                </Col>
              </Row>}
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default Footer;
